export default "__VITE_ASSET__B1osZT0r__"